import {
  Companion_getInstance3snrp0mvkuou8 as Companion_getInstance,
  Addresscpovxna1tjmg as Address,
} from './supportModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  State_Utah_getInstance3mij6nisrv8ix as State_Utah_getInstance,
  State3dw676r1r3e8w as State,
} from './enums.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_line1(_this__u8e3s4) {
  return _this__u8e3s4.prop(Address_line1_getInstance());
}
function get_line2(_this__u8e3s4) {
  return _this__u8e3s4.prop(Address_line2_getInstance());
}
function get_city(_this__u8e3s4) {
  return _this__u8e3s4.prop(Address_city_getInstance());
}
function get_state(_this__u8e3s4) {
  return _this__u8e3s4.prop(Address_state_getInstance());
}
function get_zipcode(_this__u8e3s4) {
  return _this__u8e3s4.prop(Address_zipcode_getInstance());
}
function prepareAddressFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [Address_line1_getInstance(), Address_line2_getInstance(), Address_city_getInstance(), Address_state_getInstance(), Address_zipcode_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function Address_line1$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function Address_line1$_get_name_$ref_fp6aov() {
  return (p0) => p0.k20();
}
function Address_line1$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Address_line1$_get_serializer_$ref_rw4ih2() {
  return (p0) => p0.j2j();
}
function Address_line1$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function Address_line1$_get_annotations_$ref_se8bhy() {
  return (p0) => p0.bz();
}
var Address_line1Class;
function Address_line1() {
  if (Address_line1Class === VOID) {
    class $ {
      constructor() {
        Address_line1_instance = this;
        var tmp = this;
        tmp.l55_1 = lazy(Address_line1$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.m55_1 = lazy(Address_line1$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.n55_1 = lazy(Address_line1$annotations$delegate$lambda);
        this.o55_1 = '';
        this.p55_1 = '""';
      }
      k20() {
        var tmp0 = this.l55_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Address_line1$_get_name_$ref_fp6aov(), null);
        return tmp0.f2();
      }
      q55(receiver) {
        return receiver.r55_1;
      }
      m2j(receiver) {
        return this.q55(receiver instanceof Address() ? receiver : THROW_CCE());
      }
      w55(receiver, value) {
        return receiver.x55(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Address() ? receiver : THROW_CCE();
        return this.w55(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.m55_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Address_line1$_get_serializer_$ref_rw4ih2(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.n55_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Address_line1$_get_annotations_$ref_se8bhy(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Address_line1', VOID, VOID, [SerializableProperty()]);
    Address_line1Class = $;
  }
  return Address_line1Class;
}
var Address_line1_instance;
function Address_line1_getInstance() {
  if (Address_line1_instance === VOID)
    new (Address_line1())();
  return Address_line1_instance;
}
function Address_line2$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function Address_line2$_get_name_$ref_o54tds() {
  return (p0) => p0.k20();
}
function Address_line2$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Address_line2$_get_serializer_$ref_9fkx7d() {
  return (p0) => p0.j2j();
}
function Address_line2$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function Address_line2$_get_annotations_$ref_7t4p2t() {
  return (p0) => p0.bz();
}
var Address_line2Class;
function Address_line2() {
  if (Address_line2Class === VOID) {
    class $ {
      constructor() {
        Address_line2_instance = this;
        var tmp = this;
        tmp.y55_1 = lazy(Address_line2$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.z55_1 = lazy(Address_line2$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.a56_1 = lazy(Address_line2$annotations$delegate$lambda);
        this.b56_1 = null;
        this.c56_1 = 'null';
      }
      k20() {
        var tmp0 = this.y55_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Address_line2$_get_name_$ref_o54tds(), null);
        return tmp0.f2();
      }
      q55(receiver) {
        return receiver.s55_1;
      }
      m2j(receiver) {
        return this.q55(receiver instanceof Address() ? receiver : THROW_CCE());
      }
      d56(receiver, value) {
        return receiver.x55(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Address() ? receiver : THROW_CCE();
        return this.d56(tmp, (value == null ? true : typeof value === 'string') ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.z55_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Address_line2$_get_serializer_$ref_9fkx7d(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.a56_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Address_line2$_get_annotations_$ref_7t4p2t(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Address_line2', VOID, VOID, [SerializableProperty()]);
    Address_line2Class = $;
  }
  return Address_line2Class;
}
var Address_line2_instance;
function Address_line2_getInstance() {
  if (Address_line2_instance === VOID)
    new (Address_line2())();
  return Address_line2_instance;
}
function Address_city$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function Address_city$_get_name_$ref_2qfipp() {
  return (p0) => p0.k20();
}
function Address_city$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Address_city$_get_serializer_$ref_486bh2() {
  return (p0) => p0.j2j();
}
function Address_city$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function Address_city$_get_annotations_$ref_r4has2() {
  return (p0) => p0.bz();
}
var Address_cityClass;
function Address_city() {
  if (Address_cityClass === VOID) {
    class $ {
      constructor() {
        Address_city_instance = this;
        var tmp = this;
        tmp.e56_1 = lazy(Address_city$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.f56_1 = lazy(Address_city$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.g56_1 = lazy(Address_city$annotations$delegate$lambda);
        this.h56_1 = '';
        this.i56_1 = '""';
      }
      k20() {
        var tmp0 = this.e56_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Address_city$_get_name_$ref_2qfipp(), null);
        return tmp0.f2();
      }
      q55(receiver) {
        return receiver.t55_1;
      }
      m2j(receiver) {
        return this.q55(receiver instanceof Address() ? receiver : THROW_CCE());
      }
      w55(receiver, value) {
        return receiver.x55(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Address() ? receiver : THROW_CCE();
        return this.w55(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.f56_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Address_city$_get_serializer_$ref_486bh2(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.g56_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Address_city$_get_annotations_$ref_r4has2(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Address_city', VOID, VOID, [SerializableProperty()]);
    Address_cityClass = $;
  }
  return Address_cityClass;
}
var Address_city_instance;
function Address_city_getInstance() {
  if (Address_city_instance === VOID)
    new (Address_city())();
  return Address_city_instance;
}
function Address_state$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(3);
}
function Address_state$_get_name_$ref_yl79ir() {
  return (p0) => p0.k20();
}
function Address_state$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Address_state$_get_serializer_$ref_f47ns6() {
  return (p0) => p0.j2j();
}
function Address_state$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(3);
}
function Address_state$_get_annotations_$ref_qc82vy() {
  return (p0) => p0.bz();
}
var Address_stateClass;
function Address_state() {
  if (Address_stateClass === VOID) {
    class $ {
      constructor() {
        Address_state_instance = this;
        var tmp = this;
        tmp.j56_1 = lazy(Address_state$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.k56_1 = lazy(Address_state$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.l56_1 = lazy(Address_state$annotations$delegate$lambda);
        this.m56_1 = State_Utah_getInstance();
        this.n56_1 = 'State.Utah';
      }
      k20() {
        var tmp0 = this.j56_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Address_state$_get_name_$ref_yl79ir(), null);
        return tmp0.f2();
      }
      q55(receiver) {
        return receiver.u55_1;
      }
      m2j(receiver) {
        return this.q55(receiver instanceof Address() ? receiver : THROW_CCE());
      }
      o56(receiver, value) {
        return receiver.x55(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Address() ? receiver : THROW_CCE();
        return this.o56(tmp, value instanceof State() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.k56_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Address_state$_get_serializer_$ref_f47ns6(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.l56_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Address_state$_get_annotations_$ref_qc82vy(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Address_state', VOID, VOID, [SerializableProperty()]);
    Address_stateClass = $;
  }
  return Address_stateClass;
}
var Address_state_instance;
function Address_state_getInstance() {
  if (Address_state_instance === VOID)
    new (Address_state())();
  return Address_state_instance;
}
function Address_zipcode$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(4);
}
function Address_zipcode$_get_name_$ref_7de6hc() {
  return (p0) => p0.k20();
}
function Address_zipcode$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Address_zipcode$_get_serializer_$ref_ixo8l3() {
  return (p0) => p0.j2j();
}
function Address_zipcode$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(4);
}
function Address_zipcode$_get_annotations_$ref_yuo0v9() {
  return (p0) => p0.bz();
}
var Address_zipcodeClass;
function Address_zipcode() {
  if (Address_zipcodeClass === VOID) {
    class $ {
      constructor() {
        Address_zipcode_instance = this;
        var tmp = this;
        tmp.p56_1 = lazy(Address_zipcode$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.q56_1 = lazy(Address_zipcode$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.r56_1 = lazy(Address_zipcode$annotations$delegate$lambda);
        this.s56_1 = '';
        this.t56_1 = '""';
      }
      k20() {
        var tmp0 = this.p56_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Address_zipcode$_get_name_$ref_7de6hc(), null);
        return tmp0.f2();
      }
      q55(receiver) {
        return receiver.v55_1;
      }
      m2j(receiver) {
        return this.q55(receiver instanceof Address() ? receiver : THROW_CCE());
      }
      w55(receiver, value) {
        return receiver.x55(VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Address() ? receiver : THROW_CCE();
        return this.w55(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.q56_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Address_zipcode$_get_serializer_$ref_ixo8l3(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.r56_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Address_zipcode$_get_annotations_$ref_yuo0v9(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Address_zipcode', VOID, VOID, [SerializableProperty()]);
    Address_zipcodeClass = $;
  }
  return Address_zipcodeClass;
}
var Address_zipcode_instance;
function Address_zipcode_getInstance() {
  if (Address_zipcode_instance === VOID)
    new (Address_zipcode())();
  return Address_zipcode_instance;
}
//region block: exports
export {
  get_city as get_city16w5sptiuu653,
  get_line1 as get_line11xah9qv5pazjt,
  get_line2 as get_line21zlifp7q9r4u8,
  prepareAddressFields as prepareAddressFields1ltrjfg0qd9gx,
  get_state as get_state2h1ip52e42bk8,
  get_zipcode as get_zipcodeh4z27ky940y0,
};
//endregion

//# sourceMappingURL=AddressFields.mjs.map
